module.exports = __webpack_public_path__ + "img/mountain.3151fca.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/mountain.svg
// module id = 1Xvd
// module chunks = 1